import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { StickyNoteIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores/plan-management/$clubid')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="storeManagement.premiumStores.planManagement.crumb.title" icon={StickyNoteIcon} />,
      title: <CrumbTitle id="storeManagement.premiumStores.planManagement.crumb.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
